import { render, staticRenderFns } from "./LearnMore.vue?vue&type=template&id=58ba776c&scoped=true&"
import script from "./LearnMore.vue?vue&type=script&lang=js&"
export * from "./LearnMore.vue?vue&type=script&lang=js&"
import style0 from "./LearnMore.vue?vue&type=style&index=0&id=58ba776c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ba776c",
  null
  
)

export default component.exports